var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 12a9.25 9.25 0 1 1 18.5 0c0 2.274-.82 4.356-2.181 5.966-.362-.679-.938-1.289-1.68-1.788l-.002-.001c-1.51-1.01-3.464-1.492-5.38-1.492s-3.874.482-5.392 1.49h0l-.004.003c-.742.499-1.318 1.109-1.68 1.788C3.57 16.356 2.75 14.274 2.75 12zm9.349 9.25H12a9.26 9.26 0 0 1-2.51-.344c-1.269-.357-2.426-.98-3.412-1.805.168-.564.598-1.158 1.368-1.677 1.221-.811 2.873-1.239 4.561-1.239s3.334.428 4.545 1.238c.771.519 1.202 1.113 1.37 1.677-.982.822-2.133 1.442-3.395 1.801a9.25 9.25 0 0 1-2.428.349zm-1.736 1.377C5.203 21.838 1.25 17.381 1.25 12 1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75m0-15.77c-1.404 0-2.53 1.133-2.53 2.53a2.52 2.52 0 0 0 2.389 2.518c.092-.008.19-.008.285 0 1.329-.071 2.377-1.166 2.386-2.52C14.529 8.113 13.395 6.98 12 6.98zM7.97 9.51c0-2.223 1.794-4.03 4.03-4.03 2.224 0 4.03 1.806 4.03 4.03v.004h0c-.012 2.168-1.718 3.941-3.884 4.015a.74.74 0 0 1-.132-.007c-.023 0-.034.001-.041.002-.039.005-.079.007-.119.005A4.02 4.02 0 0 1 7.97 9.51z",
    fill: "#888b8d"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.4cd79f91f54fd0cd87f36f4fb90cd1cd.svg";
export { ForwardRef as ReactComponent };